export default "__VITE_ASSET__BtpEI12v__"